enum AIGender {
  woman = "woman",
  man = "man",
}

export const aiGenderAsString = (aiGender: AIGender): string => {
  switch (aiGender) {
    case AIGender.man:
      return "Homme";
    case AIGender.woman:
      return "Femme";
    default:
      return "";
  }
};

export default AIGender;
